/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { Nullable } from 'constants/types'

/**
 * CSS related helper functions.
 */
export const CSSUtils = {
    /**
     *  Add className(s) to specified element(s)
     * @param el
     * @param className
     */
    addClass(el: Nullable<HTMLElement>, ...className: string[]): void {
        if (!className || !el) {
            return
        }

        if (Array.isArray(className)) {
            el.classList.add(...className)
            return
        }
        el.classList.add(className)
    },

    /**
     *  Remove className to specified element(s)
     * @param el
     * @param className
     */
    removeClass(el: Nullable<HTMLElement>, className?: string): void {
        if (!className || !el) {
            return
        }

        el.classList.remove(className)
    },

    /**
     * @param el
     * @param className
     */
    checkClass(el: Nullable<HTMLElement>, className: string): boolean {
        if (!el) {
            return false
        }

        if (el.classList.contains(className)) {
            return true
        } else {
            return false
        }
    }
}
